import React from 'react'
import { Figure } from '../cards/Figure'

export const Figures = () => {
    return (
        // This is the figures section
        <div className='w-full flex flex-col'>
            {/* // This is the title */}
            <div className='flex h-fit gap-4 py-28 flex-wrap w-full justify-around items-center '>
                {/* // These are the figures */}
                <Figure name="UHI Compliant" content={<p className='leading-4 text-center text-xs'>
                    <span className='font-bold'> Clinqo </span> is connected to the UHI Ecosystem of ABDM and works with all <span className='font-bold'> UHI </span> connected HMIS and PHR applications. UHI provides unique visibility to a health facility over the UHI platform over other patient booking Platforms.
                </p>} />
                <Figure name="HCX & HL7 integrated" content={<p className='leading-4 text-center text-xs'>
                    <span className='font-bold'> HCX helps </span> a healthcare facility to facilitate faster TPA’s and Billing in insurance. <span className='font-bold'> Clinqo </span> is fully HL7 compliant and secures the health data using HL7 standards and HIPAA criteria. For us, patient data safety is of primary concern.
                </p>} />
                <Figure name="AI-Based" content={<p className='leading-4 text-center text-xs'>
                    <span className='font-bold'> Clinqo </span> uses feedback based algorithms to study and analyse the patient outcomes and EHR;s to recommend AI based realtime Clinical Decision Support over the Counter. This improves the Charting capabilities and provides a wholesome view of the Patient Health to the doctor.
                </p>} />
            </div>
        </div>
    )
}
